import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
  DataAssetConfiguraionComponent
} from './data-asset-configuraion.component';

import {
  ConfigureDataAssetByIdComponent
} from './configure-data-asset-by-id/configure-data-asset-by-id.component';

const routes: Routes = [
  // Data Asset Configuration list
  {
    path: '',
    component: DataAssetConfiguraionComponent
  },

  // Configure a specific data asset
  {
    path: 'configure-data-asset/:assetId/:configurationStatus',
    component: ConfigureDataAssetByIdComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],

  exports: [
    RouterModule
  ]
})
export class DataAssetConfigurationRouter {}